import React, { useCallback, useEffect, useMemo, useState } from "react";
import axiosInstance from "../../utils/axiosConfig";
import { TailSpin } from "react-loader-spinner";

import { DataTable } from "../../components/data-table";
import { API_URL } from "../../constant";
import { useAuth } from "../../context/auth-context";
import WalletActivityModal from "./WalletActivityModal";
import {
  buildWalletActivityRows,
  createWalletActivityColumns,
  WALLET_TABLE_LIMIT,
  type WalletActivityRow,
} from "./walletActivitiesTable";

const WalletActivities = () => {
  const { isAuthenticated } = useAuth();
  const [transactions, setTransactions] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [page, setPage] = useState<number>(1);
  const [totalPages, setTotalPages] = useState<number>(1);
  const [transactionCount, setTransactionCount] = useState<number>(0);

  const [selectedTransaction, setSelectedTransaction] = useState<any>(null);
  const [activityModal, setActivityModal] = useState<boolean>(false);

  useEffect(() => {
    if (!isAuthenticated) return;
    setLoading(true);
    axiosInstance
      .get(
        `${API_URL}api/transactions?page=${page}&excludeTypes=gift-card-transactions&limit=${WALLET_TABLE_LIMIT}`
      )
      .then((r: any) => {
        setTransactions(
          Array.isArray(r?.data?.data?.transactions)
            ? r.data.data.transactions
            : []
        );
        setTotalPages(Math.max(1, r?.data?.data?.meta?.totalPages ?? 1));
        setTransactionCount(r?.data?.data?.meta?.transactionsCount ?? 0);
      })
      .catch((e: any) => {
        console.log(e?.response?.data?.message || "An error occurred");
      })
      .finally(() => setLoading(false));
  }, [isAuthenticated, page]);

  const openTransaction = useCallback((row: WalletActivityRow) => {
    setSelectedTransaction(row.raw);
    setActivityModal(true);
  }, []);

  const columns = useMemo(() => createWalletActivityColumns(), []);
  const rows = useMemo<WalletActivityRow[]>(
    () => buildWalletActivityRows(transactions),
    [transactions]
  );

  return (
    <div className="w-full pb-8">
      {loading && transactions.length === 0 ? (
        <div className="flex justify-center rounded-xl border border-[#2C363E] bg-[#161E25]/40 py-16">
          <TailSpin color="#0B75C2" height={36} width={36} />
        </div>
      ) : (
        <>
          {loading && (
            <p className="mb-2 text-[12px] text-[#869AA9]">Updating list…</p>
          )}
          <DataTable<WalletActivityRow>
            columns={columns}
            data={rows}
            currentPage={page}
            setCurrentPage={setPage}
            totalPage={totalPages}
            count={transactionCount}
            limit={WALLET_TABLE_LIMIT}
            onRowClick={openTransaction}
            emptyContent="No wallet activity to display."
            className="overflow-hidden rounded-xl border border-[#2C363E]"
            fixedBodyHeight="min(620px, 60vh)"
          />
        </>
      )}

      {activityModal && selectedTransaction && (
        <WalletActivityModal
          transaction={selectedTransaction}
          setActivityModal={setActivityModal}
        />
      )}
    </div>
  );
};

export default WalletActivities;
